import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const FilterWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
  	justify-content: flex-start;
  	margin:10px 10px 20px 0;
  	> div {
		> div {
        border-radius: 0;
		}
  .ap-button-main {
    height: 32px;
  }
`;

export const DateRangeWrapper = styled.div`
	.ap-month-picker > div {
		border: 1px solid #cccccc;
	}
	.ap-month-picker > div:hover {
		border: 1px solid ${colors.black};
	}
	.ap-month-picker > div:nth-child(2) {
		top: 24%;
		left: 16%;
	}
`;

export const Breadcrumbs = styled.div`
	display: flex;
	align-items: center;
	font-weight: 500;
	font-size: 12px;
	letter-spacing: 0.3px;
	color: ${colors.grey6};
	padding-bottom: 10px;
	span {
		cursor: pointer;
		font-size: 12px;
	}
	span:hover {
		cursor: pointer;
		color: ${colors.grey9};
	}
`;
export const LoadingContainer = styled.div`
	height: 400px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
`;

export const NoData = styled.div`
	color: ${colors.grey7};
	font-size: 16px;
	letter-spacing: 0.3px;
	padding: 32px 0 32px 4px;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 400px;
`;
